import clsx from "clsx";
import Image from "next/legacy/image";

type AvatarProps = {
  user: {
    displayName?: string;
    avatarUrl?: string;
  };
};

const Avatar = ({ user }: AvatarProps) => {
  return (
    <div
      className={clsx(
        "flex size-6 shrink-0 items-center justify-center overflow-hidden rounded-full",
        { "bg-zinc-950": !user.avatarUrl }
      )}
    >
      {user.avatarUrl ? (
        <Image
          src={user.avatarUrl}
          alt={user.displayName || ""}
          width={24}
          height={24}
        />
      ) : (
        <span className="font-body text-xs font-semibold uppercase text-white">
          {user.displayName?.charAt(0).toUpperCase()}
        </span>
      )}
    </div>
  );
};

export default Avatar;
